import React from 'react'
import { AdOrderContext } from '../contexts/AdOrder'

export default function useInput () {

  const { adOrder, setAdOrder, calcPrice, calcWeeks } = React.useContext(AdOrderContext)
  const inputsThatAffectPrice = [
    'cities',
    'date_to',
    'date_from'
  ]
  const inputsThatAffectWeeks = [
    'date_to',
    'date_from'
  ]

  const setValue = function (key, value, subobj = null) {
    let newOrder = {}
    if (subobj === null) {
      newOrder = { ...adOrder, [key]: value }
    } else {
      newOrder = { ...adOrder, [subobj]: { ...adOrder[subobj], [key]: value } }
    }
    if (inputsThatAffectWeeks.includes(key)) {
      newOrder.weeks = calcWeeks(newOrder)
    }
    if (inputsThatAffectPrice.includes(key)) {
      newOrder.price = calcPrice(newOrder)
    }
    setAdOrder(newOrder)
  }

  const getValue = function (key, subobj = null) {
    if (subobj === null) {
      return adOrder?.[key]
    } else {
      return adOrder?.[subobj]?.[key]
    }
  }

  const addValue = function (key, value, subobj = null) {
    let _value = getValue(key, subobj)
    if (!Array.isArray(_value)) {
      _value = []
    }
    if (_value.indexOf(key) < 0) {
      _value.push(value)
    }
    setValue(key, _value, subobj)
  }

  const removeValue = function (key, value, subobj = null) {
    let _value = getValue(key, subobj)
    if (!Array.isArray(_value)) {
      console.warn('Cannot remove value from non array object for object with key "' + key + '"')
    }
    let i = _value.indexOf(value)
    if (i >= 0) {
      _value.splice(i, 1)
      setValue(key, _value, subobj)
    }
  }

  const contains = function (key, value, subobj) {
    let _value = getValue(key, subobj)
    if (!Array.isArray(_value)) {
      return value === _value
    }

    return _value.indexOf(value) >= 0
  }

  return {
    setValue,
    getValue,
    addValue,
    removeValue,
    contains
  }
}